import { action } from 'satcheljs';

export const activityFeedItemsSeen = action(
    'ACTIVITY_FEED_ITEMS_SEEN',
    (itemIds: string[], resetUnseenCount: boolean) => ({
        itemIds,
        resetUnseenCount,
    })
);
